import { toastsAtom } from '@/app/states/atoms';
import { useAtom } from 'jotai';
import Alert from '../Alert';
const ToastContainer = () => {
  const [toasts] = useAtom(toastsAtom);
  return (
    <div className="fixed bottom-24 left-1/2 z-[9999999] flex -translate-x-1/2 flex-col gap-2">
      {toasts.map((toast, i) => (
        <Alert {...toast} key={i} />
      ))}
    </div>
  );
};
export default ToastContainer;
